import { render, staticRenderFns } from "./detailInstantClaim.vue?vue&type=template&id=42aea22c&scoped=true&"
import script from "./detailInstantClaim.vue?vue&type=script&lang=js&"
export * from "./detailInstantClaim.vue?vue&type=script&lang=js&"
import style0 from "./detailInstantClaim.vue?vue&type=style&index=0&id=42aea22c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aea22c",
  null
  
)

export default component.exports